import type { VisitCounselView } from './visit-counsel.types';
import type { OrderStatus } from '@/entities/order/model/order.types';

/**
 * 플래너 상담 목록에서 숨길 항목 (취소·다른 상담으로 변경)
 * useMyVisitCounselList와 동일 기준
 */
export function isPlannerCounselHiddenByOrderStatus(
  counsel: VisitCounselView,
  status: OrderStatus
): boolean {
  const { type } = status;
  if (type === 'ClosedLost' || type === 'Unqualified' || type === 'Requote') return true;
  return 'counsel' in status && status.counsel !== null && status.counsel !== counsel.id;
}
